import React from "react";
import { Row, Col, Container} from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import AboutCard from "./AboutCard"
import Toolstack from "./Toolstack";
import Home2 from "../Home/Home2";
import Skills from "./Skills"
function About() {
  return (
    <>
         <Home2 />
   
      <Particle />
      
    

      
    </>
  );
}

export default About;
